import { Backdrop, CircularProgress } from '@mui/material';
import theme from '../../../theme';

type ProgressPropsType = {
	isAsyncProcess: boolean;
};

/**
 * ローディング表示
 */
export const Progress = (props: ProgressPropsType) => {
	return (
		<Backdrop sx={{ zIndex: theme.zIndex.backdrop }} open={props.isAsyncProcess}>
			<CircularProgress data-testid="progressbar" color="primary" />
		</Backdrop>
	);
};
